import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('ILL', {
  FETCH_ILL_REQUEST: null,
  FETCH_ILL_SUCCESS: null,
  FETCH_ILL_FAILURE: null
});



// WEBPACK FOOTER //
// ./app/constants/InterlibraryLoansConstants.js